<script>
import CheckoutStep from './CheckoutStep';
import Search from './HeaderBottomMobileSearch';
import Links from './HeaderBottomMobileLinks';

export default {
  components: {
    CheckoutStep,
    Search,
    Links,
  },
  props:{
    cartRoute: String,
    checkoutRoute: String,
    cart: Object,
    isMobileSalesPage: Boolean,
    search: String,
    categories: Array,
    isWhitelabel: Boolean,
  },
};
</script>

<template lang='pug'>
.px-1_5.bg-white(v-if='!isMobileSalesPage')

  checkout-step(
    v-if='[cartRoute, checkoutRoute].includes($route.name)',
    hidden-md,
    :cart-route='cartRoute',
    :checkout-route='checkoutRoute',
    :cart-id='cart.id',
  )

  template(v-else)
    search(
      :value='search',
      @search-input='$emit("search-input", $event)',
      @perform-search='$emit("perform-search", $event)',
    )
    links(
      v-if='!isWhitelabel',
      :categories='categories',
      @toggle-shop-menu='$emit("toggle-shop-menu", $event)',
    )
</template>

<style>
@import '~import/index';

</style>